/* eslint-disable */
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";

// SLICES
import { authSlice } from "./auth";
import { articlesSlice } from "./articles";
import { tagsSlice } from "./tags";
import { usersSlice } from "./users";
import { organisationsSlice } from "./organisations";

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const store = configureStore({
  reducer: {
    router: routerReducer,
    [authSlice.name]: authSlice.reducer,
    [articlesSlice.name]: articlesSlice.reducer,
    [tagsSlice.name]: tagsSlice.reducer,
    [usersSlice.name]: usersSlice.reducer,
    [organisationsSlice.name]: organisationsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(routerMiddleware),
});

export const history = createReduxHistory(store);

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, AppState, unknown, Action>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export default store;
